var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "np_close_996783_000000") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE4B\\u200D\\u2642\\uFE0F-Punters",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Punters_Notes----Add-New",
    transform: "translate(-1299.000000, -457.000000)",
    fill: "#FF003B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(1299.027691, 457.029194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6196841,11.3872792 L9.22969032,6.99943686 L13.616457,2.60944307 C14.1227961,2.10520157 14.1227961,1.29421987 13.6185581,0.787880716 L13.2109696,0.379243399 C12.9714562,0.133426337 12.6436912,0 12.2991396,0 L12.2970385,0 C11.9524869,0 11.6289118,0.135515913 11.3873061,0.378167684 L6.99838804,4.7703129 L2.60839425,0.38354626 C2.10520157,-0.120695247 1.29526869,-0.122792892 0.788929538,0.381445388 L0.380292221,0.785887415 C0.134475159,1.02750381 0,1.35526348 0,1.69876624 C0,2.04439354 0.135515913,2.3689906 0.378167684,2.61164506 L4.7703129,7.00056314 L0.382470544,11.3905569 C-0.123868607,11.8947984 -0.123868607,12.7057801 0.380369404,13.2131681 L0.787957898,13.6207566 C1.02957429,13.8665737 1.35628514,14 1.70083672,14 C2.04329066,14 2.37106109,13.8634353 2.61266672,13.6218323 L7.00050908,9.23076281 L11.3894272,13.6167227 C11.6383961,13.8677919 11.9692914,13.9948904 12.3012572,13.9948904 C12.6300764,13.9948904 12.9588688,13.8698815 13.2109895,13.6188203 L13.618578,13.2122806 C13.8654466,12.9727673 13.9988943,12.6450022 13.9988943,12.3004506 C14.0009711,11.9558991 13.8654573,11.6302263 13.6228002,11.3875718 L13.6196841,11.3872792 Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/cross-red.442ecb81d29755290eb2c13e99ad0d0b.svg";
export { ForwardRef as ReactComponent };